import { formatMoney } from "~/utils/formatMoney"

const SitesTable = ({ data, camp }: any) => {
  return (
    <table className="min-w-full table-auto divide-y divide-gray-300">
      <thead className="sticky top-0 bg-white shadow-sm">
        <tr>
          <th scope="col" className="py-3.5 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap">
            Site Name
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Booked nights
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Blocked nights
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Available nights
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Occupancy (excluding blockers)
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Occupancy (including blockers)
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Avg. nightly rate
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Total Revenue
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {data &&
          data.map((siteData, index) => {
            const { site_name, booked, blocked, avg_rate, revenue, available, occupancy, occupancy_without_blockers } =
              siteData

            return (
              <tr className="h-10 hover:bg-gray-50" key={index}>
                <td className="font-medium flex-shrink">{site_name}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{booked}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{blocked}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{available}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{occupancy_without_blockers}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{occupancy}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{formatMoney(avg_rate, camp?.currency)}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{formatMoney(revenue, camp?.currency)}</td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export default SitesTable
